import {
  Col,
  Row,
  Space,
  Table,
  Tag,
  Card,
  Button,
  message,
  Spin,
  Select,
  Typography,
  Tooltip,
  Input,
  Popconfirm,
} from "antd";
import React, { useEffect, useMemo, useState } from "react";
import DetailModal from "../detail/DetailModal";
import {
  FormOutlined,
  CloseCircleOutlined,
  SearchOutlined,
  ReloadOutlined,
  UpSquareOutlined,
  DownSquareOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";
import MotionHoc from "../../../utils/MotionHoc";
import { Link } from "react-router-dom";
import {
  baseUrl,
  GET_INVESTIGATE_LOANS_LIST,
  HEADERS_EXPORT,
} from "../../API/apiUrls";

import axios from "axios";

import DateCustom from "../../../hook/DateCustom";
import InvestigateAssets from "./modal/InvestigateAssets";
import dayjs from "dayjs";
import EditInvestigateAssets from "./modal/EditInvestigateAssets";
import EditResponsible, {
  buildResponsibleOptions,
  getResponsibleId,
  putResponsible,
} from "./modal/EditResponsible";
import { optionsLocat } from "../../../utils/constant/LocatOption";
import { ThaiRangePicker } from "../../../hook/ThaiDatePickerNew";
import LoadLawyers from "../../../hook/LoadLawyers";

const Main = () => {
  const { Option } = Select;
  const ROLE_ID = localStorage.getItem("ROLE_ID");
  const [convertDateThai] = DateCustom();
  const userCompany = localStorage.getItem("COMPANY_ID");
  const [isModal, setIsModal] = useState(false);
  const [arrayTable, setArrayTable] = useState([]);
  const [dataArr, setDataArr] = useState([]);
  const [loading, setLoading] = useState();
  const [dataModal, setDataModal] = useState();
  const [tableLength, setTableLength] = useState(0);

  const [dataRecord, setDataRecord] = useState();
  const [isModalInvestigateAssets, setIsModalInvestigateAssets] =
    useState(false);
  const [isModalEditInvestigateAssets, setIsModalEditInvestigateAssets] =
    useState(false);
  const [isModalEditResponsible, setIsModalEditResponsible] = useState(false);
  // ผู้รับผิดชอบที่เลือกไว้ รอกดยืนยันก่อนยิง api { recordId, value }
  const [pendingResponsible, setPendingResponsible] = useState(null);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [statusId, setStatusId] = useState();
  const [datePickerJudge, setDatePickerJudge] = useState();
  const [datePickerInvestigateAsset, setDatePickerInvestigateAsset] =
    useState();
  const [searchInput, setSearchInput] = useState();
  const [arrow, setArrow] = useState("Show");
  const [advanceSearch, setAdvanceSearch] = useState(false);
  const toggle = () => setAdvanceSearch((v) => !v);

  const [lawyerId, setLawyerId] = useState();
  const [lawyerName, setLawyerName] = useState();
  const [lawyersOption, setLawyersOption] = useState();
  const [lawyersList, setLoadingData] = LoadLawyers();

  useEffect(() => {
    loadData();
    setLoadingData(true);
  }, []);

  useEffect(() => {
    if (lawyersList) {
      setOptionLawyer();
    }
  }, [lawyersList]);

  const setOptionLawyer = () => {
    let companySelect = null;

    console.log(userCompany);

    if (userCompany === "3") {
      companySelect = lawyersList.filter(
        (item) =>
          item.COMPANY_ID === 3 &&
          (item.ROLE_ID === 3 || item.ROLE_ID === 4 || item.ROLE_ID === 2) &&
          item.ACTIVE_STATUS === 1,
      );
    } else {
      companySelect = lawyersList.filter(
        (item) =>
          (item.COMPANY_ID === 1 || item.COMPANY_ID === 2) &&
          (item.ROLE_ID === 3 || item.ROLE_ID === 4) &&
          item.ACTIVE_STATUS === 1,
      );
    }
    const options = companySelect.map((item) => ({
      value: item.id,
      label: item.NNAME,
      fNmae: item.FNAME,
      lName: item.LNAME,
    }));

    options.unshift({
      value: "all", // ค่าที่แทน "ทั้งหมด"
      label: "ทั้งหมด", // ข้อความที่แสดงใน dropdown
    });

    let lawyerDefualt;
    if (userCompany === "3") {
      lawyerDefualt = 10;
    } else {
      lawyerDefualt = 3;
    }

    let lawyerSet = lawyersList.find((item) => item.id === lawyerDefualt);
    setLawyerName(lawyerSet);

    setLawyersOption(options);
  };

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  const loadData = async (data) => {
    setLoading(true);
    console.log(data);

    try {
      await axios
        .get(
          baseUrl +
            GET_INVESTIGATE_LOANS_LIST +
            `?companyId=${userCompany === "3" ? 3 : 1}`,
          {
            headers: HEADERS_EXPORT,
          },
        )
        .then(async (res) => {
          let i = 1;
          if (res.status === 200) {
            const newData = res.data.map((item) => ({
              ...item,
              key: i++,
            }));
            filterData(newData);
            console.log("res Role", newData);
          } else {
            message.error("ไม่มีข้อมูล");
            console.log("res Role", res.data);
          }
        })
        .catch((err) => {
          console.log("ไม่มีข้อมูล", err); // ถ้ามีข้อผิดพลาดอื่น ๆ ให้แสดงข้อความนี้
        });
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`ไม่พบข้อมูล: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const filterData = (data) => {
    if (data) {
      let filteredData;
      console.log("data", data);

      // ไม่แสดงสัญญาที่ MAIN_STATUS_ID = 11, 13, 14
      const hiddenMainStatus = [11, 13, 14];
      data = data.filter(
        (item) => !hiddenMainStatus.includes(item.MAIN_STATUS_ID),
      );

      if (userCompany === "3") {
        filteredData = data.filter((item) => {
          const branch = item.LOCAT;
          // ถ้า branch เป็น null หรือ undefined ให้ return true ไปเลย (หรือ false ก็ได้ ขึ้นกับความต้องการ)
          if (!branch) return true; // หรือ false ก็ได้ ถ้าอยาก "กรองออก"

          // ถ้า branch มีค่า → เช็กตามปกติ
          return (
            !optionsLocat.some((opt) => branch.includes(opt.label)) ||
            item.CONTNO.includes("UD")
          );
        });
      } else {
        filteredData = data.filter((item) => {
          const branch = item.LOCAT;
          if (!branch) return false; // ไม่มี branch ไม่ผ่านเงื่อนไข

          return optionsLocat.some((opt) => branch.includes(opt.label));
        });
      }

      console.log("filteredData", filteredData);

      const sortedData = filteredData.sort((a, b) => {
        // ถ้า a ไม่มี judge_date ให้เอาไว้ล่าง
        if (!a.judge_date && b.judge_date) return 1;
        // ถ้า b ไม่มี judge_date ให้เอาไว้ล่าง
        if (a.judge_date && !b.judge_date) return -1;
        // ถ้าทั้งคู่มี judge_date ให้เปรียบเทียบปกติ (ล่าสุดก่อน)
        if (a.judge_date && b.judge_date) {
          return new Date(a.judge_date) - new Date(b.judge_date);
        }
        return 0; // ถ้าทั้งคู่เป็น null
      });

      setArrayTable(sortedData);
      setDataArr(filteredData);
      setTableLength(sortedData?.length);
      console.log("newData", sortedData);
      console.log("Length of filtered data:", sortedData?.length);
    } else {
      console.error("data is not an array or is undefined");
      setTableLength(0);
    }
  };

  const onExpand = (expanded, record) => {
    if (expanded) {
      // เมื่อแถวถูกขยาย, ให้เพิ่ม key ของแถวนั้นลงใน expandedRowKeys
      setExpandedRowKeys([record.key]);
    } else {
      // เมื่อแถวถูกยุบ, ให้ลบ key ของแถวนั้นออกจาก expandedRowKeys
      setExpandedRowKeys([]);
    }
  };

  const search = (event) => {
    console.log("query--->", event.target.value);
    setSearchInput(event.target.value);
  };
  // เปลี่ยนผู้รับผิดชอบรายสัญญา บันทึกทันทีและอัพเดทเฉพาะ record นั้น (ไม่ reload)
  const onChangeResponsible = async (value, record) => {
    setPendingResponsible(null);
    setLoading(true);
    try {
      const res = await putResponsible(record.WORK_LOG_ID, value);
      if (res.status !== 200) {
        message.error(`แก้ไขผู้รับผิดชอบ ${record.CONTNO} ไม่สำเร็จ`);
        return;
      }
      const updateRow = (list) =>
        list?.map((item) =>
          item.id === record.id
            ? {
                ...item,
                working_log_list: item.working_log_list?.map((log) =>
                  log.id === item.WORK_LOG_ID
                    ? { ...log, USER_ID: value }
                    : log,
                ),
              }
            : item,
        );
      setDataArr((prev) => updateRow(prev));
      setArrayTable((prev) => updateRow(prev));
      message.success(`แก้ไขผู้รับผิดชอบ ${record.CONTNO} สำเร็จ`);
      message.warning(`ระบบยังไม่ถูกโหลดใหม่จนกว่ารีเฟลซ`);
    } catch (error) {
      console.error("แก้ไขผู้รับผิดชอบไม่สำเร็จ:", error);
      message.error(`แก้ไขผู้รับผิดชอบ ${record.CONTNO} ไม่สำเร็จ`);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateData = (data) => {
    console.log("data---->update", data);
    console.log("dataArr", dataArr);
    if (data) {
      const result = dataArr.map((item) => {
        if (item.id === data.id) {
          return { ...data };
        } else {
          return { ...item };
        }
      });
      const newData = result.filter((item) => !item.investigation_status);
      console.log("result", newData);
      setDataArr(newData);
      setArrayTable(newData);
    } else {
      loadData();
      console.log("handleUpdateData loadData");
    }
  };

  //ทำ render record ของตาราถ้าใช้ logic เยอะ
  const renderDataAssetBefor = (record) => {
    //ส่งค่า null ออกไปถ้า record นี่ยังไม่มี

    if (record.investigation_status === null) {
      return null;
    }

    let color =
      record.investigation_status === 0
        ? "red"
        : record.investigation_status === 1
          ? "green"
          : record.investigation_status === 2
            ? "green"
            : "blue";

    return (
      <Tag color={color} key={record.id} style={{ textAlign: "center" }}>
        {/* {record.investigation_status < 3 ? "สืบหลังฟ้อง" : "สืบก่อนฟ้อง"}
        <br /> */}
        {record.investigation_status === 0
          ? "ไม่เจอทรัพย์"
          : record.investigation_status === 1
            ? "เจอทรัพย์"
            : record.investigation_status === 2
              ? "อายัดเงินได้"
              : null}
        <br />
        {record.investigation_status === 5
          ? null
          : "สืบครั้งที่ " + record.investigation_log_count}
      </Tag>
    );
  };

  const renderOpteionStatus = () => {
    return (
      <>
        <Option value={4}>
          <span style={{ marginRight: 8 }}>🗂️</span>
          ทั้งหมด
        </Option>
        <Option value={1}>
          <CloseCircleOutlined style={{ color: "red", marginRight: 8 }} />
          ไม่เจอทรัพย์
        </Option>
        <Option value={2}>⚡ มีคำพิพากษาแล้ว</Option>
      </>
    );
  };

  const onChangeSelectStatus = (value) => {
    console.log("onChangeSelectStatus-->", value);

    setStatusId(value);
  };

  //ทำ render record ของตาราถ้าใช้ logic เยอะ
  const renderDate = (record) => {
    //ส่งค่า null ออกไปถ้า record นี่ยังไม่มี
    if (!record.investigation_date) {
      return null;
    }
    let color;
    const recordDate = dayjs(record.investigation_date);
    const today = dayjs().startOf("day");

    // คำนวณความแตกต่างในหน่วยปี
    const yearsDifference = today.diff(recordDate, "year");

    // คำนวณความแตกต่างในหน่วยเดือน
    const monthsDifference = today.diff(recordDate, "month");

    // คำนวณความแตกต่างในหน่วยวัน
    const daysDifference = today.diff(recordDate, "day");

    // คำนวณส่วนที่เหลือหลังจากคำนวณปีแล้ว (คำนวณเดือนที่เหลือ)
    const remainingMonths = today
      .subtract(yearsDifference, "year")
      .diff(recordDate, "month");

    // คำนวณส่วนที่เหลือหลังจากคำนวณปีและเดือนแล้ว (คำนวณวันที่เหลือ)
    const remainingDays = today
      .subtract(yearsDifference, "year")
      .subtract(remainingMonths, "month")
      .diff(recordDate, "day");

    if (record.investigation_status === 0) {
      color = yearsDifference >= 1 ? "orange" : "red";
    } else if (record.investigation_status === 1) {
      color = "blue";
    } else if (record.investigation_status === 2) {
      color = "green";
    } else {
      color = "blue";
    }
    const formattedDate = record.investigation_date
      ? convertDateThai(recordDate)
      : null;
    return (
      <Tag color={color} key={daysDifference} style={{ textAlign: "center" }}>
        {formattedDate}
        <br />
        {
          <span>
            {yearsDifference} ปี {remainingMonths} เดือน {remainingDays} วัน
          </span>
        }
      </Tag>
    );
  };

  const renderDateJudge = (record) => {
    //ส่งค่า null ออกไปถ้า record นี่ยังไม่มี
    if (!record.judge_date) {
      return null;
    }
    let color;
    const recordDate = dayjs(record.judge_date);
    const today = dayjs().startOf("day");

    // คำนวณความแตกต่างในหน่วยปี
    const yearsDifference = today.diff(recordDate, "year");

    // คำนวณความแตกต่างในหน่วยเดือน
    const monthsDifference = today.diff(recordDate, "month");

    // คำนวณความแตกต่างในหน่วยวัน
    const daysDifference = today.diff(recordDate, "day");

    // คำนวณส่วนที่เหลือหลังจากคำนวณปีแล้ว (คำนวณเดือนที่เหลือ)
    const remainingMonths = today
      .subtract(yearsDifference, "year")
      .diff(recordDate, "month");

    // คำนวณส่วนที่เหลือหลังจากคำนวณปีและเดือนแล้ว (คำนวณวันที่เหลือ)
    const remainingDays = today
      .subtract(yearsDifference, "year")
      .subtract(remainingMonths, "month")
      .diff(recordDate, "day");

    if (remainingMonths >= 1 || yearsDifference > 0) {
      color = "orange";
    } else if (remainingMonths < 1) {
      color = "blue";
    } else if (remainingMonths > 12) {
      color = "red";
    }

    const formattedDate = record.judge_date
      ? convertDateThai(recordDate)
      : null;
    return (
      <Tag color={color} key={daysDifference} style={{ textAlign: "center" }}>
        {formattedDate}
        <br />
        {
          <span>
            {yearsDifference} ปี {remainingMonths} เดือน {remainingDays} วัน
          </span>
        }
      </Tag>
    );
  };

  const onChangeJudgeDate = (dates) => {
    setDatePickerJudge(dates);
    setDatePickerInvestigateAsset(null); // เคลียร์อีกอัน
  };

  const onChangeInvestigateDate = (dates) => {
    setDatePickerInvestigateAsset(dates);
    setDatePickerJudge(null); // เคลียร์อีกอัน

    console.log(datePickerInvestigateAsset);
    console.log(datePickerJudge);
  };

  const onQueryData = () => {
    let result = [...dataArr];
    console.log(result);

    // filter จาก input
    if (searchInput && searchInput.trim() !== "") {
      result = result.filter(
        (item) =>
          item?.CONTNO?.includes(searchInput.trim()) ||
          item?.CUSTOMER_LNAME?.includes(searchInput.trim()) ||
          item?.CUSTOMER_FNAME?.includes(searchInput.trim()),
      );
    }

    // filter จาก select (statusId)
    if (statusId) {
      if (statusId === 1) {
        result = result.filter((item) => item.investigation_status === 0);
      } else if (statusId === 2) {
        result = result.filter((item) => item.investigation_status === 1);
      } else if (statusId === 3) {
        result = result.filter(
          (item) => item.investigation_status === null && item.judge_date,
        );
      }
    }

    // filter จาก date (เลือกได้ทีละอัน)
    if (datePickerJudge && datePickerJudge.length === 2) {
      const start = dayjs(datePickerJudge[0]).startOf("day").valueOf();
      const end = dayjs(datePickerJudge[1]).endOf("day").valueOf();

      result = result.filter((item) => {
        const date = dayjs(item.judge_date).valueOf();
        return date >= start && date <= end;
      });
    } else if (
      datePickerInvestigateAsset &&
      datePickerInvestigateAsset.length === 2
    ) {
      const start = dayjs(datePickerInvestigateAsset[0])
        .startOf("day")
        .valueOf();
      const end = dayjs(datePickerInvestigateAsset[1]).endOf("day").valueOf();

      result = result.filter((item) => {
        const date = dayjs(item.investigation_date).valueOf();
        return date >= start && date <= end;
      });
    }

    if (result.length > 0) {
      setArrayTable(result);
      setTableLength(result.length);
    } else {
      message.error("ไม่พบข้อมูล");
      setArrayTable(result);
      setTableLength(result.length);
    }
  };

  const columns = [
    {
      title: "ลำดับ",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: "10%",
      render: (text, object, key) => key + 1,
      sorter: {
        compare: (a, b) => a.key - b.key,
        multiple: 5,
      },
    },
    {
      title: "เลขที่สัญญา",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
      render: (text, record) => (
        <Link
          onClick={() => {
            setIsModal(true);
            setDataRecord(record);
          }}
        >
          {record.CONTNO ? record.CONTNO : null}
        </Link>
      ),
    },
    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "CUSTOMER_TNAM",
      key: "CUSTOMER_TNAM",
      align: "center",
      render: (text, record) => (
        <>
          {record.CUSTOMER_TNAME ? record.CUSTOMER_TNAME : null}{" "}
          {record.CUSTOMER_FNAME ? record.CUSTOMER_FNAME : null}{" "}
          {record.CUSTOMER_LNAME ? record.CUSTOMER_LNAME : null}
        </>
      ),
    },
    {
      title: "วันที่พิพากษา",
      align: "center",
      render: (record) => <>{renderDateJudge(record)}</>,
    },
    {
      title: "สถานะ",
      align: "center",
      render: (record) => <>{renderDataAssetBefor(record)}</>,
    },
    {
      title: "วันที่สืบทรัพย์",
      align: "center",
      render: (record) => <>{renderDate(record)}</>,
      // sorter: (a, b) => {
      //   // กรณีถ้า a.investigation_date เป็น null ให้ขึ้นก่อน
      //   if (a.investigation_date === null) return -1;
      //   if (b.investigation_date === null) return 1;

      //   // เปรียบเทียบวันที่ระหว่าง a.investigation_date และ b.investigation_date
      //   const dateA = dayjs(a.investigation_date);
      //   const dateB = dayjs(b.investigation_date);

      //   if (dateA.isBefore(dateB)) return -1;
      //   if (dateA.isAfter(dateB)) return 1;
      //   return 0; // ถ้าเท่ากัน
      // },
      // defaultSortOrder: "ascend", // กำหนดการเรียงลำดับเริ่มต้น
      // sortDirections: ["ascend", "descend"], // เพิ่มการรองรับการสลับลำดับ
    },
    {
      title: "ผู้สืบล่าสุด",
      align: "center",
      render: (record) => <>{record?.LAWYER_NNAME || null}</>,
    },
    {
      title: "ผู้รับผิดชอบ",
      align: "center",
      width: 200,
      render: (record) => {
        const userId = getResponsibleId(record);
        const isPending = pendingResponsible?.recordId === record.id;
        return (
          <Popconfirm
            title="แก้ไขผู้รับผิดชอบ"
            description={`คุณต้องการเปลี่ยนผู้รับผิดชอบสัญญา ${record.CONTNO} ใช่หรือไม่ ?`}
            open={isPending}
            onConfirm={() =>
              onChangeResponsible(pendingResponsible.value, record)
            }
            onCancel={() => setPendingResponsible(null)}
            okText="ยืนยัน"
            cancelText="ยกเลิก"
          >
            <Select
              showSearch
              placeholder="เลือกผู้รับผิดชอบ"
              optionFilterProp="label"
              popupMatchSelectWidth={false}
              value={
                (isPending ? pendingResponsible.value : userId) ?? undefined
              }
              onChange={(value) => {
                if (value === userId) {
                  setPendingResponsible(null);
                  return;
                }
                setPendingResponsible({ recordId: record.id, value });
              }}
              options={buildResponsibleOptions(lawyersOption, lawyersList, [
                userId,
              ])}
              disabled={!record.WORK_LOG_ID}
              style={{ width: "100%" }}
            />
          </Popconfirm>
        );
      },
    },
  ];

  return (
    <>
      <Card>
        <Row>
          <Col span={"12"} style={{ textAlign: "start", marginBottom: "10px" }}>
            <Input
              placeholder="ค้นหาสัญญา"
              onChange={search}
              style={{
                width: 200,
                marginRight: 10,
              }}
              value={searchInput}
              size="large"
            />
            <Select
              placeholder="เลือกสถานะ"
              optionFilterProp="value"
              popupMatchSelectWidth={false}
              onChange={(value) => onChangeSelectStatus(value)}
              style={{
                width: "auto",
              }}
              size="large"
              value={statusId}
            >
              {renderOpteionStatus()}
            </Select>
            <div style={{ marginTop: 10 }}>
              <Space direction="horizontal" size={8}>
                <Tooltip
                  title={advanceSearch ? "ซ่อนตัวกรอง" : "แสดงตัวกรอง"}
                  arrow={mergedArrow}
                >
                  {!advanceSearch ? (
                    <DownSquareOutlined
                      style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                      onClick={toggle} // antd ส่งค่า checked มาให้
                    />
                  ) : (
                    <UpSquareOutlined
                      style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                      onClick={toggle} // antd ส่งค่า checked มาให้
                    />
                  )}
                </Tooltip>
                <Button
                  icon={<ReloadOutlined />}
                  onClick={() => {
                    setSearchInput(null);
                    setStatusId(null);
                    setDatePickerJudge(null);
                    setDatePickerInvestigateAsset(null);
                  }}
                  style={{
                    color: "red",
                    borderRadius: "8px",
                    fontWeight: "bold",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  ล้าง
                </Button>
                <Button
                  type="primary"
                  icon={<SearchOutlined />}
                  size="large"
                  style={{
                    borderRadius: "8px",
                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                    fontWeight: "bold",
                    background: "linear-gradient(135deg, #667eea, blue)",
                    border: "none",
                  }}
                  onClick={onQueryData}
                  loading={loading}
                >
                  ค้นหา
                </Button>
              </Space>
            </div>
          </Col>

          <Col span={"12"} style={{ textAlign: "end", marginBottom: "10px" }}>
            <Space>
              <Button
                icon={<UserSwitchOutlined />}
                onClick={() => setIsModalEditResponsible(true)}
                disabled={!arrayTable.length}
              >
                แก้ไขผู้รับผิดชอบ
              </Button>
              <Button
                icon={<ReloadOutlined />}
                disabled={!arrayTable.length}
                onClick={() => {
                  setPendingResponsible(null);
                  loadData();
                }}
                style={{
                  color: "blue",
                  borderRadius: "8px",
                  fontWeight: "bold",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                }}
              >
                โหลดข้อมูลใหม่
              </Button>
            </Space>
          </Col>
          <Col>
            {advanceSearch ? (
              <Col span={24} style={{ textAlign: "start" }}>
                <Space
                  direction="vertical"
                  size={8}
                  style={{ marginRight: 10 }}
                >
                  <Typography.Text strong>
                    ค้นหาจากวันที่พิพากษา
                  </Typography.Text>

                  <ThaiRangePicker
                    value={datePickerJudge}
                    onChange={onChangeJudgeDate}
                    size="large"
                  />
                </Space>

                <Space direction="vertical" size={8}>
                  <Typography.Text strong>
                    ค้นหาจากวันที่สืบทรัพย์
                  </Typography.Text>
                  <ThaiRangePicker
                    value={datePickerInvestigateAsset}
                    onChange={onChangeInvestigateDate}
                    size="large"
                  />
                </Space>
              </Col>
            ) : null}
          </Col>
        </Row>
      </Card>
      <Card>
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Row>
            <Col span={"24"}>
              <Table
                size="small"
                columns={columns}
                dataSource={arrayTable}
                scroll={{ x: 850 }}
                footer={() => <p>จำนวนสัญญาทั้งหมด {tableLength}</p>}
                expandable={{
                  expandedRowRender: (record) => (
                    <p style={{ margin: 0 }}>
                      {/* {!record.investigation_date ? ( */}
                      <Button
                        style={{
                          boxShadow: "0 4px 3px",
                          marginRight: "10px",
                        }}
                        onClick={() => {
                          setIsModalInvestigateAssets(true);
                          setDataModal(record);
                        }}
                      >
                        <FormOutlined
                          style={{ color: "blue", fontSize: "16px" }}
                        />
                      </Button>
                      {/* ) : null} */}

                      {/* {record.investigation_date ? (
                        <Button
                          style={{
                            boxShadow: "0 4px 3px",
                            marginRight: "10px",
                          }}
                          onClick={() => {
                            setIsModalEditInvestigateAssets(true);
                            setDataModal(record);
                          }}
                        >
                          <FormOutlined
                            style={{ color: "orange", fontSize: "16px" }}
                          />
                        </Button>
                      ) : null} */}
                    </p>
                  ),
                  rowExpandable: (record) =>
                    ROLE_ID === "2" ||
                    ROLE_ID === "3" ||
                    ROLE_ID === "4" ||
                    ROLE_ID === "1",
                  expandedRowKeys, // เก็บ state ของ row ที่ขยาย
                  onExpand, // ฟังก์ชันที่ควบคุมการขยาย
                }}
                rowKey="key"
              />
            </Col>
          </Row>
        </Spin>
      </Card>
      {isModal ? (
        <DetailModal open={isModal} close={setIsModal} dataRec={dataRecord} />
      ) : null}
      {isModalInvestigateAssets ? (
        <InvestigateAssets
          open={isModalInvestigateAssets}
          close={setIsModalInvestigateAssets}
          dataDefualt={dataModal}
          funcUpdateStatus={handleUpdateData}
        />
      ) : null}
      {isModalEditInvestigateAssets ? (
        <EditInvestigateAssets
          open={isModalEditInvestigateAssets}
          close={setIsModalEditInvestigateAssets}
          dataDefualt={dataModal}
          funcUpdateStatus={handleUpdateData}
        />
      ) : null}
      {isModalEditResponsible ? (
        <EditResponsible
          open={isModalEditResponsible}
          close={setIsModalEditResponsible}
          dataList={dataArr}
          lawyersOption={lawyersOption}
          lawyersList={lawyersList}
          funcReload={loadData}
        />
      ) : null}
    </>
  );
};

const CreateInvestigateAssets = MotionHoc(Main);
export default CreateInvestigateAssets;
